import {
    TextField,
    Label,
    Input,
    Button,
    TextFieldProps,
  } from "react-aria-components";
  import { useFormContext } from "react-hook-form";
  import React from "react";
  
  interface InputFieldProps extends TextFieldProps {
    label: string;
    description?: string;
    name: string;
    fieldId?: string;
    message?: string;
    isDisabled?: boolean;
    isRequired?: boolean;
    errorText?: string;
    customStyle?: string;
    visible?: boolean;
    showIcon?: boolean;
    handleChange?: () => void;
    labelLeft?: boolean;
    placeHolder?: string; 
  }
  
  const InputField: React.FC<InputFieldProps> = ({
    label,
    description,
    name,
    fieldId,
    message,
    isDisabled = false,
    isRequired = false,
    errorText,
    customStyle,
    visible = false,
    showIcon = false,
    handleChange,
    labelLeft = false,
    placeHolder = " ", 
    ...props
  }) => {
    const leftLabelCss = labelLeft ? "flex gap-4 w-full items-start" : "";
  
    const {
      setValue,
      getValues,
      clearErrors,
      formState: { errors },
    } = useFormContext();
  
    const fieldName = name || "";
    const errorMessage = errors[fieldName]?.message
      ? errors[fieldName]?.message?.toString()
      : errorText || "";
  
    const value = getValues(fieldName);
  
    return (
      <TextField {...props} isInvalid={!!errorMessage} className={`${leftLabelCss}`}>
        <div className="grid grid-cols-1">
          <Label className="font-medium text-sm text-gray-400">{label}</Label>
          <div className="flex items-center h-[32px] md:h-[48px] border-[0.5px] md:border border-[#B32C90] md:border-gray-300 p-2 px-4 rounded-[3px] md:rounded-normal focus:outline-none">
            <Input
              autoComplete="off"
              value={value}
              disabled={isDisabled}
              className={`w-full text-primary focus:outline-none placeholder:font-normal placeholder:text-primary ${customStyle} ${
                isDisabled ? "cursor-not-allowed bg-gray-300" : ""
              }`}
              placeholder={placeHolder}
              onChange={(e) => {
                clearErrors(fieldName);
                setValue(fieldName, e.target.value);
              }}
              id={fieldId}
            />
            {visible && (
              <Button onPress={handleChange} className="focus:outline-none">
                <img
                  src={showIcon ? "/icons/visible.svg" : "/icons/visible-off.svg"}
                  alt="visible"
                  className="h-5 w-5 focus:outline-none"
                />
              </Button>
            )}
          </div>
          {(errorMessage || message) && (
            <div
              className={`bg-transparent flex items-center gap-2 rounded-md mt-2 ${
                message === "Unknown error occurred" ||
                message === "Incorrect password"
                  ? "hidden"
                  : ""
              }`}
            >
              <img
                src="/icons/error.svg"
                alt="success"
                className="w-[16px] h-[16px]"
              />
              {message && (
                <span className=" text-[#DC2626] text-small w-full">
                  {message === "Incorrect password"
                    ? "Incorrect password, please try again!"
                    : message}
                </span>
              )}
              {errorMessage && (
                <span className=" text-[#DC2626] text-small">{errorMessage}</span>
              )}
              {message === "Email already registered" && (
                <div className="text-gray-400 text-small font-normal w-full text-end">
                  <a href="/forgot-password" className=" text-[#B32C90] mx-1">
                    Forgot Password?
                  </a>
                </div>
              )}
            </div>
          )}
        </div>
      </TextField>
    );
  };
  
  export default InputField;
  